// @flow
export default class Step {
  name: string;
  enabled : boolean;
  active: boolean;
  slug: string;
  slugEng: string;

  constructor(name:string, enabled:boolean, active:boolean, slug:string, slugEng:string) {
    this.name = name;
    this.enabled = enabled;
    this.active = active;
    this.slug = slug;
    this.slugEng = slugEng;
  }
}
